import { render, staticRenderFns } from "./IpTargetting.vue?vue&type=template&id=11568b39&"
import script from "./IpTargetting.vue?vue&type=script&lang=ts&"
export * from "./IpTargetting.vue?vue&type=script&lang=ts&"
import style0 from "./IpTargetting.vue?vue&type=style&index=0&id=11568b39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports